'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = contentReactions;

var _actionTypes = require('../../actions/action-types');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function currentUserReactions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];
  var reaction = action.payload.reaction;


  switch (action.type) {
    case _actionTypes.REQUEST_ADD_REACTION:
    case _actionTypes.FAIL_REMOVE_REACTION:
      return [].concat(_toConsumableArray(state), [reaction]);
    case _actionTypes.REQUEST_REMOVE_REACTION:
    case _actionTypes.FAIL_ADD_REACTION:
      var reactionIndex = state.lastIndexOf(reaction);
      if (reactionIndex === -1) {
        return state;
      }

      return [].concat(_toConsumableArray(state.slice(0, reactionIndex)), _toConsumableArray(state.slice(reactionIndex + 1)));
    default:
      return state;
  }
}

function existingReactions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];
  var newReactions = arguments[2];
  var reaction = action.payload.reaction;
  var _newReactions$reactio = newReactions[reaction].count,
      count = _newReactions$reactio === undefined ? 0 : _newReactions$reactio;


  var reactionIndex = state.lastIndexOf(reaction);
  var reactionExists = reactionIndex !== -1;

  switch (action.type) {
    case _actionTypes.REQUEST_ADD_REACTION:
    case _actionTypes.FAIL_REMOVE_REACTION:
      if (count < 1 || reactionExists) {
        return state;
      }

      return [reaction].concat(_toConsumableArray(state));
    case _actionTypes.REQUEST_REMOVE_REACTION:
    case _actionTypes.FAIL_ADD_REACTION:
      if (count > 0 || !reactionExists) {
        return state;
      }

      return [].concat(_toConsumableArray(state.slice(0, reactionIndex)), _toConsumableArray(state.slice(reactionIndex + 1)));
    default:
      return state;
  }
}

function reactions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var reaction = action.payload.reaction;

  var _ref = state[reaction] || {},
      _ref$count = _ref.count,
      count = _ref$count === undefined ? 0 : _ref$count,
      _ref$shouldAnimateIn = _ref.shouldAnimateIn,
      shouldAnimateIn = _ref$shouldAnimateIn === undefined ? false : _ref$shouldAnimateIn,
      _ref$shouldAnimateOut = _ref.shouldAnimateOut,
      shouldAnimateOut = _ref$shouldAnimateOut === undefined ? false : _ref$shouldAnimateOut;

  switch (action.type) {
    case _actionTypes.REQUEST_ADD_REACTION:
    case _actionTypes.FAIL_REMOVE_REACTION:
      return Object.assign({}, state, _defineProperty({}, reaction, {
        count: count + 1,
        shouldAnimateIn: shouldAnimateIn,
        shouldAnimateOut: shouldAnimateOut
      }));
    case _actionTypes.REQUEST_REMOVE_REACTION:
    case _actionTypes.FAIL_ADD_REACTION:
      return Object.assign({}, state, _defineProperty({}, reaction, {
        count: Math.max(0, count - 1),
        shouldAnimateIn: shouldAnimateIn,
        shouldAnimateOut: shouldAnimateOut
      }));
    case _actionTypes.SET_REACTION_SHOULD_ANIMATE_IN:
      var nextShouldAnimateIn = action.payload.shouldAnimateIn;

      return Object.assign({}, state, _defineProperty({}, reaction, {
        count: count,
        shouldAnimateIn: nextShouldAnimateIn,
        shouldAnimateOut: shouldAnimateOut
      }));
    case _actionTypes.SET_REACTION_SHOULD_ANIMATE_OUT:
      var nextShouldAnimateOut = action.payload.shouldAnimateOut;

      return Object.assign({}, state, _defineProperty({}, reaction, {
        count: count,
        shouldAnimateIn: shouldAnimateIn,
        shouldAnimateOut: nextShouldAnimateOut
      }));
    default:
      return state;
  }
}

function addContentReaction(state, action) {
  var _action$payload = action.payload,
      communityContentType = _action$payload.communityContentType,
      communityContentRelatedId = _action$payload.communityContentRelatedId,
      contentReaction = _action$payload.contentReaction;

  var communityContentIdKey = communityContentType + '-' + communityContentRelatedId;
  return Object.assign({}, state, _defineProperty({}, communityContentIdKey, Object.assign({}, contentReaction)));
}

function updateContentReactions(state, action) {
  var _action$payload2 = action.payload,
      communityContentType = _action$payload2.communityContentType,
      communityContentRelatedId = _action$payload2.communityContentRelatedId;

  var communityContentIdKey = communityContentType + '-' + communityContentRelatedId;

  var _ref2 = state[communityContentIdKey] || {},
      _ref2$reactions = _ref2.reactions,
      oldReactions = _ref2$reactions === undefined ? {} : _ref2$reactions,
      _ref2$currentUserReac = _ref2.currentUserReactions,
      oldCurrentUserReactions = _ref2$currentUserReac === undefined ? [] : _ref2$currentUserReac,
      _ref2$existingReactio = _ref2.existingReactions,
      oldExistingReactions = _ref2$existingReactio === undefined ? [] : _ref2$existingReactio,
      _ref2$reactionMessage = _ref2.reactionMessageParts,
      oldReactionMessageParts = _ref2$reactionMessage === undefined ? [] : _ref2$reactionMessage,
      _ref2$reactionMessage2 = _ref2.reactionMessagePartsAlternate,
      oldReactionMessagePartsAlternate = _ref2$reactionMessage2 === undefined ? [] : _ref2$reactionMessage2;

  if (action.type === _actionTypes.RECEIVE_COMM_CONTENT_METADATA) {
    return Object.assign({}, state, _defineProperty({}, communityContentIdKey, {
      reactions: action.payload.responseData.reactions,
      currentUserReactions: action.payload.responseData.currentUserReactions,
      existingReactions: [],
      reactionMessageParts: action.payload.responseData.reactionMessageParts,
      reactionMessagePartsAlternate: action.payload.responseData.reactionMessagePartsAlternate
    }));
  }

  var newReactions = reactions(oldReactions, action);

  // If user removes all of his/her reactions from feedcard swap
  // or if the user adds his/her first reaction to the feedcard,
  // swap the reaction details message
  if (action.type === _actionTypes.REQUEST_REMOVE_REACTION && oldCurrentUserReactions.length === 1 || action.type === _actionTypes.REQUEST_ADD_REACTION && oldCurrentUserReactions.length === 0 || action.type === _actionTypes.FAIL_REMOVE_REACTION && oldCurrentUserReactions.length === 0 || action.type === _actionTypes.FAIL_ADD_REACTION && oldCurrentUserReactions.length === 1) {
    return Object.assign({}, state, _defineProperty({}, communityContentIdKey, {
      reactions: newReactions,
      currentUserReactions: currentUserReactions(oldCurrentUserReactions, action),
      existingReactions: existingReactions(oldExistingReactions, action, newReactions),
      reactionMessageParts: oldReactionMessagePartsAlternate,
      reactionMessagePartsAlternate: oldReactionMessageParts
    }));
  }

  return Object.assign({}, state, _defineProperty({}, communityContentIdKey, {
    reactions: newReactions,
    currentUserReactions: currentUserReactions(oldCurrentUserReactions, action),
    existingReactions: existingReactions(oldExistingReactions, action, newReactions),
    reactionMessageParts: oldReactionMessageParts,
    reactionMessagePartsAlternate: oldReactionMessagePartsAlternate
  }));
}

function addReactionsFromFeedItem() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var feedItem = arguments[1];

  if (!feedItem.content.communityContentId || !feedItem.reactions) return state;

  var _feedItem$content$com = feedItem.content.communityContentId,
      type = _feedItem$content$com.type,
      relatedId = _feedItem$content$com.relatedId;

  var communityContentIdKey = type + '-' + relatedId;
  return Object.assign({}, state, _defineProperty({}, communityContentIdKey, {
    reactions: feedItem.reactions,
    currentUserReactions: feedItem.currentUserReactions,
    existingReactions: Object.keys(feedItem.reactions),
    reactionMessageParts: feedItem.reactionMessageParts,
    reactionMessagePartsAlternate: feedItem.reactionMessagePartsAlternate
  }));
}

function contentReactions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var newState = void 0;
  switch (action.type) {
    case _actionTypes.ADD_CONTENT_REACTION:
      return addContentReaction(state, action);
    case _actionTypes.REQUEST_ADD_REACTION:
    case _actionTypes.FAIL_ADD_REACTION:
    case _actionTypes.REQUEST_REMOVE_REACTION:
    case _actionTypes.FAIL_REMOVE_REACTION:
    case _actionTypes.SET_REACTION_SHOULD_ANIMATE_IN:
    case _actionTypes.SET_REACTION_SHOULD_ANIMATE_OUT:
      return updateContentReactions(state, action);
    case _actionTypes.RECEIVE_COMM_CONTENT_METADATA:
      var _action$payload3 = action.payload,
          communityContentType = _action$payload3.communityContentType,
          communityContentRelatedId = _action$payload3.communityContentRelatedId;

      var communityContentIdKey = communityContentType + '-' + communityContentRelatedId;
      return Object.assign({}, state, _defineProperty({}, communityContentIdKey, {
        reactions: action.payload.responseData.reactions,
        currentUserReactions: action.payload.responseData.currentUserReactions,
        existingReactions: Object.keys(action.payload.responseData.reactions),
        reactionMessageParts: action.payload.responseData.reactionMessageParts,
        reactionMessagePartsAlternate: action.payload.responseData.reactionMessagePartsAlternate
      }));
    case _actionTypes.ADD_FEED_ITEMS:
      newState = state;
      if (action.payload.feedItems) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = action.payload.feedItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var feedItem = _step.value;

            newState = addReactionsFromFeedItem(newState, feedItem);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      return newState;
    case _actionTypes.RECEIVE_MINI_PROFILE:
    case _actionTypes.RECEIVE_USER_TIMELINE:
      newState = state;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = action.payload.response.feedItems[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _feedItem = _step2.value;

          newState = addReactionsFromFeedItem(newState, _feedItem);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return newState;
    case _actionTypes.RECEIVE_FEED_ITEM:
      return addReactionsFromFeedItem(state, action.payload.response);
    default:
      return state;
  }
}